<highcharts-chart
  [Highcharts]="Highcharts"
  [constructorType]="'chart'"
  [options]="chartOptions"
  [runOutsideAngular]="true"
  style="width: 100%; height: 400px; display: block"
></highcharts-chart>
